import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum IdentityComparisonStep {
  Compare = 'Compare',
  Fail = 'Fail',
  Bypass = 'Bypass',
}

export const identityComparisonFlow: CheckinWorkflow<IdentityComparisonStep> = {
  id: FlowId.IdentityComparison,
  entry: IdentityComparisonStep.Compare,
  steps: {
    [IdentityComparisonStep.Compare]: {
      id: IdentityComparisonStep.Compare,
      page: PageKey.IDENTITY_COMPARISON,
      next: (variables) =>
        variables.isIdentityComparaisonSuccess
          ? { complete: true }
          : { nextStep: IdentityComparisonStep.Fail },
    },
    [IdentityComparisonStep.Fail]: {
      id: IdentityComparisonStep.Fail,
      page: PageKey.IDENTITY_COMPARISON_FAIL,
      next: () => ({ bubble: 'exit' }),
      bypass: () => ({ nextStep: IdentityComparisonStep.Bypass }),
    },
    [IdentityComparisonStep.Bypass]: {
      id: IdentityComparisonStep.Bypass,
      page: PageKey.BYPASS,
      next: () => ({ complete: true }),
      back: () => ({ nextStep: IdentityComparisonStep.Compare }),
    },
  },
};
